// extracted by mini-css-extract-plugin
module.exports = {"dashHeader":"css_dashHeader__2QoE0","propertyRow":"css_propertyRow__2-DYd","timeframeRow":"css_timeframeRow__HAo4s"};